module.exports = __webpack_public_path__ + "img/call-center-status-half.5eb8c1e9.png";